/**
 * The tail every Storytell id carries after its `<entity>_` prefix.
 *
 * The suffix is an xid, so its alphabet is base32-hex and the last character carries a single bit
 * of the final byte: only "0" or "g" can ever appear there. Anything looser passes ids that the
 * backend's parser rejects, which is how a filter built from one reaches the wire and comes back 400.
 *
 * It lives on its own, outside the barrel, so a call site that only needs the pattern inside a
 * larger expression does not pull zod and the id schemas into its bundle.
 */
export const ID_SUFFIX_PATTERN = "[0-9a-v]{19}[0g]";
